<template lang="html">
  <div class="selection-container">
    <div class="pl-subheading">
      Will your students be anonymous to each other?
      <i
        v-my-tooltip="anonymity_description"
        class="fa fa-info-circle"
        aria-hidden="true"
      >
      </i>
    </div>

    <!-- Anonymity Radio Selection Buttons -->
    <div class="radio-button-container">
      <div class="row" style="margin: 10px 10px 10px 0px">
        <pl-radio v-model="anonymity_status" :value="false" />
        <span>No, student names are revealed.</span>
      </div>
      <div class="row" style="margin: 10px 10px 10px 0px">
        <pl-radio v-model="anonymity_status" :value="true" />
        <span>Yes, students are anonymous.</span>
      </div>
    </div>
    <div class="close-button end-xs">
      <pl-button
        v-if="user_has_changed_status"
        @click.native="updateAnonymityStatus"
        :disabled="!user_has_changed_status"
        class="pl-primary"
      >
        Save Changes
      </pl-button>
      <pl-button v-else @click.native="$emit('closeTab')"> Close </pl-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        anonymity_status: false,
        anonymity_description:
          'We can assign a character to each student, replacing\n' +
          'their real identities during the discussion. <br/>\n' +
          '<br/>\n' +
          '* Anonymity does not apply to the author of the RoundTable',
      };
    },
    computed: {
      user_has_changed_status() {
        return this.anonymity_status !== this.getCurrentRT.enable_annonymous;
      },
      ...mapGetters(['getCurrentRT']),
    },
    methods: {
      updateAnonymityStatus() {
        this.$store.dispatch(
          'analytics',
          'edit written roundtable - change anonymity status'
        );
        this.$store.dispatch('savingRTDetails', {
          id: this.getCurrentRT.id,
          enable_annonymous: this.anonymity_status,
        });
      },
    },
    mounted() {
      // Set up the appopriate current status of anon
      this.anonymity_status = this.getCurrentRT.enable_annonymous;
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'

    .close-button
      border-top: 2px solid pl-fog;
      padding: 15px 0;

    .fa-info-circle
      font-size: 12px

    .selection-container
      margin-top: 15px

    .radio-button-container
      margin-left: 20px
      margin-bottom: 15px
</style>



// WEBPACK FOOTER //
// anonymitySettingsTab.vue?9b80d8b6